import {UsersList} from '@flexinet/users-components';

/**
 * The read-only users tab embedded on account, application and organization
 * pages. The list itself is the shared @flexinet/users-components view
 * (FNP-2016); this file only supplies the console's own routes.
 *
 * `scopeId` is sent to users-api as the account scope. Each page passes its
 * `:id` route parameter, exactly as the console's own users list read it
 * before the move.
 */
export const UsersTab = ({scopeId}: { scopeId?: string }) => (
    <UsersList
        accountId={scopeId}
        getUserHref={user => `/users/${user.id}`}
        getAccountHref={user => `/accounts/${user.accountId}`}
        homeHref='/dashboard'
    />
);
